import * as React from 'react';
import './about.css';
import { graphql, useStaticQuery } from 'gatsby';

export function About(): React.ReactElement {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "scale-and-hammer.jpg" }) {
        childImageSharp {
          # Specify a fixed image and fragment.
          # The default width is 400 pixels
          fixed(width: 1500) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);
  return (
    <section
      id="about"
      style={{
        background: `url(${data.file.childImageSharp.fixed.src}) right bottom`,
      }}
    >
      <div className="about-wrapper">
        <div className="about-content container">
          <div className="row">
            <div className="col-md-8">
              <p>
                Kancelarię Adwokacką <strong>Advocare</strong> współtworzą adwokat{' '}
                <strong>Anna Sklinda-Maciejewska</strong> oraz adwokat{' '}
                <strong>Alicja Wojciechowska</strong>.
              </p>
              <p>
                Dzięki zespołowi adwokatów o różnych specjalnościach Kancelaria zapewnia kompleksową
                pomoc prawną swoim klientom.
              </p>
              <p>
                Kancelaria udziela pomocy prawnej klientom indywidualnym, a także zapewnia bieżącą
                obsługę prawną klientom biznesowym.
              </p>
              <p>
                Współdziałanie w prowadzonych sprawach pozwala na wypracowanie optymalnych rozwiązań
                oraz zapewnienie maksymalnej dyspozycyjności dla klienta.
              </p>
              <p>
                Kancelaria w każdej zleconej sprawie zachowuje najwyższy poziom merytoryczności i
                profesjonalizmu, jednocześnie dbając o to, aby klienci kancelarii rozumieli swoją
                sytuację prawną. Podejmowane w trakcie współpracy działania zawsze zmierzają do
                uzyskania najlepszego rezultatu przy jak najmniejszym zaangażowaniu czasu i finansów
                klienta.
              </p>
            </div>
            <div className="col-md-4" />
          </div>
        </div>
      </div>
    </section>
  );
}
